import type { NavigateFunction } from 'react-router-dom';
import { ROUTES } from '@/app/router/routes';
import { analyticsService } from '@/services/analytics/analyticsService';
import { showToast } from '@/utils/globalToast';

/**
 * Bookmark and Apply need an account. Flutter sends a signed-out visitor to the login page
 * without a word (Bookmark), or opens the application in a new tab that lands on the login page
 * (Apply), once per click. Here the visitor is told why, and goes to the sign-in page in the
 * same tab with the route state that brings them back afterwards (postLoginRedirect).
 */
export const SIGN_IN_TO_SAVE_JOB = 'Please sign in to save this job';
export const SIGN_IN_TO_APPLY = 'Please sign in to apply for this job';

/** Clicks within this window after a redirect are ignored (double clicks, impatient taps). */
const REPEAT_WINDOW_MS = 1500;
let lastRedirectAt = 0;

/**
 * Tell the visitor sign-in is needed, then open /login with `state` (a LoginRedirectState).
 * Logs the screen_view Flutter's navigateTo(loginRoute) logs. Returns false for a repeated click.
 */
export function redirectToSignIn(navigate: NavigateFunction, message: string, state?: unknown): boolean {
  const now = Date.now();
  if (now - lastRedirectAt < REPEAT_WINDOW_MS) return false;
  lastRedirectAt = now;
  // Global toast: it stays up across the navigation to /login
  showToast(message, 'info', 3000);
  void analyticsService.logScreenView({ screenName: ROUTES.LOGIN });
  navigate(ROUTES.LOGIN, { state });
  return true;
}
